import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { CheckBox } from "../core/components/checkBox";
import { TextBox } from "../core/components/textBox";
import { General } from "../../siteManagement/general";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { Entity } from "../core/components/commonApp";
import React from "react"
export default class EditLenght extends React.Component<EditLenghtProps, EditLenghtState> {
    private factory = ComponentHelper.createFactory();
    private oldValue: number;
    private lockedOnMax: boolean;
    private minLenght: number;
    private sheet: Sheet;
    private lock: boolean;
    constructor(props: EditLenghtProps) {
        super(props);
        const tryParse = (value): number => {
            let result: number;
            if (!Helper.hasValue(value) || Helper.isNullOrEmpty(value.toString)) {
                result = -1;
            } else {
                result = parseInt(value);
            }
            if (result > 8000) {
                result = -1;
            }
            return result;
        }
        let value = tryParse(props.value);
        if (value > -1 && props.entity.IsNew) {
            this.lock = true;
        }
        this.state = {
            max: value.toString() === "-1",
            value: value
        }
        this.oldValue = this.state.value;
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.initApp();
    }

    private initApp = () => {
        this.setSettings();
        this.setEvents();
    }

    private setEvents = () => {
        this.sheet.bind(SheetEventType.Custom, this.handleLock)
        this.sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
            this.setSettings();
            this.setState({});
        });
    }

    private handleLock = (data) => {
        let cmd = Helper.getAttributeSavely(data, "cmd");
        switch (cmd) {
            case "lockDataType":
                let value = (data.lenght as number);
                if(Helper.hasValue(value)){
                    this.onChange(value);
                }
                break;
            case "unlockDataType":
                this.lock = false;
                this.onChange(this.oldValue)
                break;
        }
        this.setState({})
    }

    private onChange = (value: number) => {
        if (value === -1) {
            this.oldValue = this.state.value;
            this.setState({ max: true, value: -1 }, () => { this.props.onChange(this.props.field, -1) })
        } else {
            this.oldValue = value;
            this.setState({ max: false, value: value }, () => { this.props.onChange(this.props.field, value) })
        }

    }

    private setSettings = () => {
        this.lockedOnMax = !this.props.entity.IsNew && this.state.max;
        this.minLenght = this.props.entity.IsNew ? 1 : this.props.value;
    }

    private createNumericTextBox = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.value;
        props.field.min = this.minLenght;
        props.field.max = 8000;
        props.disabled = this.props.disabled || this.lock;
        props.onChange = (field, value) => {
            this.onChange(value);
        }
        return (
            <div style={{ width: (!this.lock && !this.lockedOnMax) ? "50%" : "100%" }}>
                <IsNumericTextBox {...props}/>
            </div>
            );
    }

    private createTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = "Max";
        props.disabled = true;
        return (
            <div style={{ width: !this.lockedOnMax ? "50%" : "100%" }}>
                <TextBox {...props} />
            </div>
        );
    }

    private createCheckBox = () => {
        let props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.max || this.lockedOnMax;
        props.onChange = (field, value: boolean) => {
            if (value) {
                this.onChange(-1);
            } else {
                this.onChange(this.oldValue === -1 ? 32 : this.oldValue);
            }
        }

        return (
            <div style={{ width: "35%", display: "flex", alignItems: "baseline" }}>
                <label style={{
                    marginRight: "7px",
                    marginLeft: "7px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "inline-block",
                    height: "18px",
                    width: "auto"
                }} title={this.props.context.translations["WebCRM.EditIndividualFields.UseMaxLenght"]}>
                    {this.props.context.translations["WebCRM.EditIndividualFields.UseMaxLenght"]}
                </label>
                <CheckBox {...props} />
            </div>
        );
    }

    componentWillUnmount() {
        this.sheet.unbind(SheetEventType.Custom, this.handleLock)
    }


    render() {
        return (
            <div style={{ display: "flex", alignItems: "baseline" }}>
                {this.state.max ? this.createTextBox() : this.createNumericTextBox()}
                {(!this.props.disabled && !this.lockedOnMax && !this.lock) ? this.createCheckBox() : null}
            </div>
        );
    }

}

interface EditLenghtProps {
    disabled: boolean;
    field: {
        model: string
    };
    onChange: (field, value) => void;
    value: any;
    entity: Entity;
    context: {
        translations: {}
    }
}

interface EditLenghtState {
    value: number;
    max: boolean;
}